import type { CommunityDetail } from '@pba/react-network';
import { Card } from 'ui';
import { UserAvatarPopover } from 'features/users';
import { useCommunityMembersQuery } from '../../queries';
import { useCommunityMembersWithoutAdministrators } from './hooks';

const PAGE_SIZE = 10;

type P = {
  community: CommunityDetail;
};

const CommunityMembers = ({ community }: P) => {
  const { data: members, isLoading } = useCommunityMembersQuery({ communityId: community.id, pageSize: PAGE_SIZE });
  const membersWithoutAdministrators = useCommunityMembersWithoutAdministrators({ community, members });

  if (!isLoading && membersWithoutAdministrators?.length === 0) {
    return null;
  }

  return isLoading || !membersWithoutAdministrators ? (
    <Card.HorizontalScroll.EntitySkeleton />
  ) : (
    <Card.HorizontalScroll
      items={membersWithoutAdministrators.map((member) => ({
        children: <UserAvatarPopover popoverProps={{ stretch: true }} user={member} />,
        key: member.id,
      }))}
      title="Members"
    />
  );
};

export default CommunityMembers;
